export default __webpack_public_path__ + "static/media/mail.1e5c83b0.svg";